import { useEffect, useState } from 'react';

export const usePortal = () => {
  const isBrowser = typeof window !== 'undefined';
  const [container] = useState(() => (isBrowser ? document.createElement('div') : null));

  useEffect(() => {
    if (!container || !isBrowser) return;

    document.body.appendChild(container);

    return () => {
      if (document.body.contains(container)) {
        document.body.removeChild(container);
      }
    };
  }, [container, isBrowser]);

  return container;
};
